An opaque cursor to the earlier bounding page.

Resulting items will _succeed_ this cursor.
